import { render, staticRenderFns } from "./FunctionCard.vue?vue&type=template&id=2334754b&scoped=true&"
import script from "./FunctionCard.vue?vue&type=script&lang=js&"
export * from "./FunctionCard.vue?vue&type=script&lang=js&"
import style0 from "./FunctionCard.vue?vue&type=style&index=0&id=2334754b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2334754b",
  null
  
)

export default component.exports